"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cast = exports.getEnumStringEntries = exports.getEnumStringValues = exports.getEnumKeys = exports.toID = exports.toName = exports.copyAndClear = exports.partialize = exports.deNull = exports.definedOrThrow = exports.asArray = exports.zip = exports.partition = exports.sum = exports.inplaceRemoveIf = exports.inplaceRemove = exports.twoWayDifference = exports.oneWayDifference = exports.hasIntersection = exports.intersection = exports.range = exports.playerColorClass = void 0;
const playerColorClass = (color, type) => {
    const prefix = {
        shadow: 'player_shadow_color_',
        bg_transparent: 'player_translucent_bg_color_',
        bg: 'player_bg_color_',
    }[type];
    return `${prefix}${color}`;
};
exports.playerColorClass = playerColorClass;
const range = (n) => Array.from(Array(n).keys());
exports.range = range;
function intersection(a, b) {
    return a.filter((e) => b.includes(e));
}
exports.intersection = intersection;
function hasIntersection(a, b) {
    return a.some((e) => b.includes(e));
}
exports.hasIntersection = hasIntersection;
function oneWayDifference(a, b) {
    const remainder = [...a];
    for (const elem of b) {
        inplaceRemove(remainder, elem);
    }
    return remainder;
}
exports.oneWayDifference = oneWayDifference;
function twoWayDifference(a, b) {
    return a
        .filter((x) => !b.includes(x))
        .concat(b.filter((x) => !a.includes(x)));
}
exports.twoWayDifference = twoWayDifference;
function inplaceRemove(array, element) {
    return inplaceRemoveIf(array, (e) => e === element) !== undefined;
}
exports.inplaceRemove = inplaceRemove;
function inplaceRemoveIf(array, predicate) {
    const idx = array.findIndex(predicate);
    if (idx === -1) {
        return undefined;
    }
    const element = array[idx];
    array.splice(idx, 1);
    return element;
}
exports.inplaceRemoveIf = inplaceRemoveIf;
function sum(array) {
    return array.reduce((a, b) => a + b, 0);
}
exports.sum = sum;
function partition(source, predicate) {
    return source.reduce((result, element) => {
        result[predicate(element) ? 0 : 1].push(element);
        return result;
    }, [[], []]);
}
exports.partition = partition;
function zip(first, second) {
    return first.map((e, i) => [e, second[i]]);
}
exports.zip = zip;
function asArray(elem) {
    return Array.isArray(elem) ? elem : [elem];
}
exports.asArray = asArray;
function definedOrThrow(obj) {
    if (obj === undefined) {
        throw new Error('object is undefined');
    }
    return obj;
}
exports.definedOrThrow = definedOrThrow;
function deNull(array) {
    const output = [];
    for (const elem of array) {
        if (elem !== undefined) {
            output.push(elem);
        }
    }
    return output;
}
exports.deNull = deNull;
function partialize(record) {
    const partial = {};
    for (const e in record) {
        if (record[e] !== 0) {
            partial[e] = record[e];
        }
    }
    return partial;
}
exports.partialize = partialize;
function copyAndClear(array) {
    const copy = [...array];
    array.length = 0;
    return copy;
}
exports.copyAndClear = copyAndClear;
function toName(item) {
    return item.name;
}
exports.toName = toName;
function toID(item) {
    return item.id;
}
exports.toID = toID;
function getEnumKeys(enumObject) {
    return Object.keys(enumObject);
}
exports.getEnumKeys = getEnumKeys;
function getEnumStringValues(enumObject) {
    return Object.values(enumObject);
}
exports.getEnumStringValues = getEnumStringValues;
function getEnumStringEntries(enumObject) {
    return Object.entries(enumObject);
}
exports.getEnumStringEntries = getEnumStringEntries;
function cast(obj, klass) {
    if (klass === undefined) {
        if (obj !== undefined) {
            throw new Error(`Expected undefined, got type ${obj.constructor.name}`);
        }
        return undefined;
    }
    if (!(obj instanceof klass)) {
        throw new Error(`Not an instance of ${klass.name}: ${obj?.constructor?.name}`);
    }
    return obj;
}
exports.cast = cast;
